import type { PreviousVersionLegalDocumentData } from '@/api/kubik/monolith'

export const sortPreviousDocumentVersionsByAscendingCreationDate = (
  versions: Readonly<PreviousVersionLegalDocumentData[]>,
): PreviousVersionLegalDocumentData[] => {
  const sortedVersions = [...versions]

  return sortedVersions.sort((a, b) => {
    const aCreationDateInMS = Number(new Date(a.creationDate))
    const bCreationDateInMS = Number(new Date(b.creationDate))

    return aCreationDateInMS - bCreationDateInMS
  })
}
